export default "__VITE_ASSET__d7e97946__"